<template>
  <section :class="$style.template">
    <header :class="$style.header">
      <p :class="$style.label">{{ template.label }}</p>
    </header>
    <div :class="[$style.template__body, $style.body]">
      <p>{{ template.body }}</p>
      <ul :class="$style.selections">
        <li
          v-for="(selection, index) in template.selections"
          :key="index"
          :class="$style.selections__item"
        >
          <ChatMessageTemplateSelectionChip :selection="selection" />
        </li>
      </ul>
    </div>
    <footer :class="[$style.template__footer, $style.footer]">
      <FlatButton
        variant="secondary"
        size="medium"
        :class="$style.footer__button"
        @click="$emit('cancel')"
      >
        キャンセル
      </FlatButton>
      <FlatButton
        :class="$style.footer__button"
        variant="caution"
        size="medium"
        @click="$emit('delete')"
      >
        このテンプレートを削除する
      </FlatButton>
    </footer>
  </section>
</template>

<script setup lang="ts">
import ChatMessageTemplateSelectionChip from './ChatMessageTemplateSelectionChip.vue'
import type { ChatMessageTemplate } from '@/types/app'
import FlatButton from '@/components/atoms/FlatButton.vue'

defineProps<{
  template: ChatMessageTemplate
}>()

defineEmits<{
  (event: 'cancel'): void
  (event: 'delete'): void
}>()
</script>

<style lang="scss" module>
.template {
  display: flex;
  flex-direction: column;

  &__body {
    overflow-y: scroll;
    flex: 1;
    padding: 16px 0;
    margin-top: 12px;
  }

  &__footer {
    border-top: 1px $color-border-low-emphasis solid;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  white-space: pre-wrap;
  word-break: break-all;
}

.label {
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
}

// 見えないしクリックできない状態にしたいが、３点リーダーボタンがないことが原因で
// テンプレタイトルの改行表示が若干変わるのを防ぐため、
// v-showではなくこのスタイルを当てる
.invisible {
  opacity: 0;
  pointer-events: none;
}

.body {
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 14px;
  line-height: 24px;
}

.selections {
  margin-top: 16px;

  &__item {
    &:nth-child(n + 2) {
      margin-top: 4px;
    }
  }
}

.items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px;
}

.item {
  display: flex;
  align-items: center;
  width: 50px;

  &--dustbox {
    color: $color-surface-accent-red;
  }

  &__text {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}

.footer {
  &__button {
    &:nth-child(n + 2) {
      margin-left: 12px;
    }
  }
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;

  &__text {
    font-weight: bold;
  }
}
</style>
